import Vue from 'vue'
import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import moment from 'moment';
import QRCode from 'qrcode';
import get_uuid from 'nllib/src/common/get_uuid';
import {Loading} from 'element-ui';

import web_credit_checkRefundStatus from '../../../../../../lib/data-service/wallet/web_credit_checkRefundStatus';

import payment_getPayChannel from '../../../../../../lib/data-service/payment/payment_getPayChannel';
import web_credit_refund from '../../../../../../lib/data-service/default/web_credit_refund';

import call_ccb_pc_data_interface from '../../../../../../lib/common-service/yinzhilv/call_ccb_pc_data_interface';
import call_UnionPay_b2b_data_interface from '../../../../../../lib/common-service/yinzhilv/call_UnionPay_b2b_data_interface';
import call_UnionPay_b2c_data_interface from '../../../../../../lib/common-service/yinzhilv/call_UnionPay_b2c_data_interface';
import amount_rounded_to_cents from '../../../../../../../../src/common-service/amount_rounded_to_cents';
import icbc_jufutong_open_page from "../../../../../../lib/common-service/yinzhilv/icbc-jufutong/open_page";

if (!Vue.prototype._) {
    Vue.prototype._ = _;
}
global._ = _;
global.moment = moment;

const comment_function = function () {
    const paymentChannelList = [
        {
            "code": 6,
            "text": "授信",
        },
        {
            "code": 4,
            "text": "胤钱宝",
        },
        {
            "code": 3,
            "text": "个人网银",
        },
        {
            "code": 9,
            "text": "企业网银",
        },
        {
            "code": 10,
            "text": "个人信用卡网银",
        },
        {
            "code": 2,
            "text": "支付宝",
        },
        {
            "code": 1,
            "text": "微信",
        },
        {
            "code": 5,
            "text": "易宝支付",
        }
    ];
};

export default {
    components: {},
    props: {
        situation: {
            type: String,
            default: `100`,
        },
    },
    data() {
        return {
            selected_payment_channel_code: -1,

            data_payment_getPayChannel: {
                paymentChannels: [],
            },
            data_web_credit_refund: {
                outTradeNo: ``,
            },

            paymentChannelEntityList: [],

            dialog_qrcode: {
                visible: false,
                title: `请打开支付宝扫码本二维码`,
                image_url: `https://yinzhilv-timed-task-bucket-alpha.oss-cn-shenzhen.aliyuncs.com/generate-tourism-product-data/alpha/P15459067/P15459067-qrcode.png`,
            },

            btn_pay: {
                id: `btn-pay-${get_uuid()}`,
                disabled: false,
                type: `primary`,
                text: `支付`,
            },

            loading: {
                instance: null,
                flag: false,
            },

            timer_to_check_payment_status: {
                id_setInterval: null,
            },

            situationParameter: {
                '100': {
                    refundType: 1,
                    orderAmount: 0,
                }
            },

        }
    },
    computed: {
        selected_payment_channel_entity() {
            const __this = this;
            let paymentChannelEntity = _.chain(__this.paymentChannelEntityList)
                .find(function (m) {
                    return m.code === __this.selected_payment_channel_code;
                })
                .value()
            ;
            if (!paymentChannelEntity) paymentChannelEntity = {};
            return paymentChannelEntity;
        }
    },
    watch: {
        selected_payment_channel_code(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_amount();
        },
        payment_channel_code_list_shou_xin(pNewValue, pOldValue) {
            const __this = this;
            __this.__init_payment_amount();
        },
    },
    methods: {
        __getSituationParameter() {
            const __this = this;

            if (!_.isFunction(__this.__getSituationParameter__)) {
                const msg = '__getSituationParameter parameter error, code=001';
                console.error(msg);
                console.trace();
                return;
            }

            const o1 = __this.__getSituationParameter__();
            if (!o1) {
                const msg = '__getSituationParameter parameter error, code=002';
                console.error(msg);
                console.trace();
                return;
            }

            const o2 = o1[`100`];
            if (!o2) {
                const msg = '__getSituationParameter parameter error, code=003';
                console.error(msg);
                console.trace();
                return;
            }

            return o1;
        },

        __init_payment_channel() {
            const __this = this;

            return Q.when()
                .then(function (data) {
                    const companyId = __this.__getSituationParameter()[`100`].companyId;
                    const orderAmount = __this.__getSituationParameter()[`100`].orderAmount;
                    return payment_getPayChannel({
                        companyId: companyId,
                        isUseCredit: false,
                        payAmount: orderAmount,
                        type: 2,
                    });

                })
                .then(function (data) {
                    __this.data_payment_getPayChannel = data;

                    const paymentChannelEntityList = _.chain(__this.data_payment_getPayChannel.paymentChannels)
                        .map(function (m) {
                            const o = extend({}, m);
                            o.payment_amount_string = `0.00`;
                            o.payment_amount_number = Number.parseFloat(o.payment_amount_string);
                            return o;
                        })
                        .value()
                    ;
                    __this.paymentChannelEntityList = paymentChannelEntityList;
                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
                ;
        },

        __init_payment_amount() {
            const __this = this;

            const orderAmount = __this.__getSituationParameter()[`100`].orderAmount;

            _.each(__this.paymentChannelEntityList, function (m) {
                m.payment_amount_string = `0.00`;
                m.payment_amount_number = Number.parseFloat(m.payment_amount_string);
            });

            const paymentChannelEntity = _.chain(__this.paymentChannelEntityList)
                .find(function (m) {
                    return m.code === __this.selected_payment_channel_code;
                })
                .value()
            ;
            if (!paymentChannelEntity) return;

            paymentChannelEntity.payment_amount_string = amount_rounded_to_cents(orderAmount);
            paymentChannelEntity.payment_amount_number = Number.parseFloat(paymentChannelEntity.payment_amount_string);

        },

        __start_timer_to_check_payment_status(pParameter) {
            const __this = this;

            if (!pParameter) pParameter = {};
            const tradeNo = pParameter.tradeNo;
            if (!tradeNo) {
                const msg = '__start_timer_to_check_payment_status parameter error, code=001';
                console.error(msg);
                return Q.reject({msg: msg});
            }

            const check_function = web_credit_checkRefundStatus;
            const paymentStatus_success = 3;
            const paymentStatus_failure = 4;
            // "订单状态：1.待支付，2.支付中，3.支付成功，4.支付失败"

            __this.timer_to_check_payment_status.id_setInterval = setInterval(function () {
                Q.when()
                    .then(function () {
                        return check_function({
                            tradeNo,
                        });
                    })
                    .then(function (data) {
                        const paymentStatus = data.paymentStatus;
                        if (_.contains([paymentStatus_success, paymentStatus_failure], paymentStatus)) {
                            //paymentStatus
                            //支付状态：0：待支付 1：支付中 2：已支付 3：支付失败
                            __this.__stop_timer_to_check_payment_status();
                            __this.__close_loading();

                            if (paymentStatus === paymentStatus_success) {
                                __this.dialog_qrcode.visible = false;
                                __this.btn_pay.disabled = true;
                                __this.btn_pay.type = `success`;
                                __this.btn_pay.text = `支付成功`;
                                const pay_successful_event_handler = __this.pay_successful_event_handler;
                                if (_.isFunction(pay_successful_event_handler)) {
                                    pay_successful_event_handler();
                                    return;
                                }

                            }

                            if (paymentStatus === paymentStatus_failure) {
                                const pay_failed_event_handler = __this.pay_failed_event_handler;
                                if (_.isFunction(pay_failed_event_handler)) {
                                    pay_failed_event_handler();
                                    return;
                                }
                                alert(`支付失败！`);
                            }

                        }
                    })
                    .catch(function (ex) {
                        console.error(ex);
                        if (ex) {
                            if (ex.stack) {
                                console.error(ex.stack);
                            }
                        }
                        return Q.reject(ex);
                    })
                ;
            }, 2 * 1000);

        },

        __stop_timer_to_check_payment_status() {
            const __this = this;
            clearInterval(__this.timer_to_check_payment_status.id_setInterval)
        },

        __close_loading() {
            const __this = this;
            __this.loading.flag = false;

            if (!__this.loading.instance) return;
            __this.loading.instance.close();
        },

        __btn_pay_click() {
            const __this = this;

            let payment_channel_entity = __this.selected_payment_channel_entity;

            const before_pay_event_handler = __this.before_pay_event_handler;
            let promise_before_pay_event_handler = Q.when();
            if (_.isFunction(before_pay_event_handler)) {
                promise_before_pay_event_handler = promise_before_pay_event_handler
                    .then(function () {
                        return before_pay_event_handler();
                    })
                ;
            }

            return Q.when()
                .then(function () {
                    return promise_before_pay_event_handler;
                })
                .then(function () {
                    //授信支付（6）、钱钱支付（4）需要输入支付密码
                    if (_.contains([6, 4], payment_channel_entity.code)) {
                        return __this.$prompt('', '请输入支付密码', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputType: 'password',
                            inputValidator(pValue) {
                                const flag = !!pValue;
                                return flag;
                            },
                            inputErrorMessage: `请输入支付密码！`,
                        });
                    }

                    return Q.resolve({
                        value: ``,
                    });
                })
                .then(function (data) {
                    const password = data.value;

                    __this.loading.instance = Loading.service({
                        // target: `#${__this.btn_pay.id}`,
                    });
                    __this.loading.flag = true;

                    const refundType = __this.__getSituationParameter()[`100`].refundType;
                    const paymentChannel = __this.selected_payment_channel_code;
                    const orderAmount = __this.__getSituationParameter()[`100`].orderAmount;
                    const billIds = __this.__getSituationParameter()[`100`].billIds;
                    const businessContent = __this.__getSituationParameter()[`100`].businessContent;
                    const orderNo = __this.__getSituationParameter()[`100`].orderNo;

                    const p = {
                        refundType: refundType,
                        paymentChannel: paymentChannel,
                        orderAmount: orderAmount,
                        password: password,
                        billIds: billIds,
                        businessContent: businessContent,
                        orderNo: orderNo,
                    };
                    return web_credit_refund(p);

                })
                .then(function (data) {
                    __this.data_web_credit_refund = data;

                    if (payment_channel_entity.code === 4) {
                        //钱包支付
                    }

                    if (payment_channel_entity.code === 2) {
                        //支付宝支付
                        const resultMap = data.resultMap;
                        const ALIPAY = resultMap.ALIPAY;
                        return QRCode.toDataURL(ALIPAY).then(function (url) {
                            __this.dialog_qrcode.title = `请打开支付宝扫码本二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    if (payment_channel_entity.code === 1) {
                        //微信支付
                        const resultMap = data.resultMap;
                        const WECHAT = resultMap.WECHAT;
                        return QRCode.toDataURL(WECHAT).then(function (url) {
                            __this.dialog_qrcode.title = `请打开微信扫码本二维码`;
                            __this.dialog_qrcode.image_url = url;
                            __this.dialog_qrcode.visible = true;
                        });
                    }

                    if (_.contains([3, 9, 10], payment_channel_entity.code)) {
                        //3.个人网银
                        //9.企业网银
                        //10.个人信用卡网银
                        const resultMap = data.resultMap;
                        const BODY = resultMap.BODY;
                        const CONTENTTYPE = resultMap.CONTENTTYPE;
                        const INFO = resultMap.INFO;
                        const SIGN = resultMap.SIGN;
                        return call_ccb_pc_data_interface({
                            BODY,
                            CONTENTTYPE,
                            INFO,
                            SIGN,
                        }).then(function () {
                            __this.__close_loading();
                        });
                    }

                    if (payment_channel_entity.code === 7) {
                        //企业银联
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2b_data_interface(resultMap).then(function () {
                            __this.__close_loading();
                        });
                    }

                    if (payment_channel_entity.code === 8) {
                        //个人银联
                        const resultMap = data.resultMap;
                        return call_UnionPay_b2c_data_interface(resultMap).then(function () {
                            __this.__close_loading();
                        });
                    }

                    if (payment_channel_entity.code === 14) {
                        //工行聚富通b2c
                        const htmlStr = data.htmlStr;
                        icbc_jufutong_open_page({
                            htmlStr,
                        });
                        __this.__close_loading();
                        return Q.resolve();
                    }

                    if (payment_channel_entity.code === 17) {
                        //工行聚富通b2b
                        const htmlStr = data.htmlStr;
                        const url_001 = `yinzhilv-open-ie:${htmlStr}`;
                        const url_002 = url_001.replace(/&/gi, `yinzhilv-open-ie-separator`);//一定要将&替换成yinzhilv-open-ie-separator，否则参数会丢失
                        global.open(url_002);
                        __this.__close_loading();
                        return Q.resolve();
                    }

                    if (payment_channel_entity.code === 5) {
                        //易宝支付
                        const htmlStr = data.htmlStr;
                        global.open(htmlStr);
                        __this.__close_loading();
                        return Q.resolve();
                    }

                })
                .then(function () {
                    const paymentOrder = __this.data_web_credit_refund.outTradeNo;//永远用toPay返回的那个outTradeNo
                    __this.__start_timer_to_check_payment_status({
                        tradeNo: paymentOrder,
                    });
                })
                .catch(function (ex) {
                    __this.__close_loading();
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    // return Q.reject(ex);
                })
                ;

        },

        __btn_payment_channel_entity_row_click(p_payment_channel_entity) {
            const __this = this;

            const payment_channel_entity = p_payment_channel_entity;
            const usable = payment_channel_entity.usable;
            const code = payment_channel_entity.code;

            if (usable) {
                __this.selected_payment_channel_code = code;
            }
        },

        __set_payment_channel_disabled(pEntity) {
            const __this = this;
            if (__this.btn_pay.disabled) {
                return true;
            }
            if (__this.loading.flag) {
                return true;
            }
            if (!pEntity.usable) {
                return true;
            }
            return false;
        },

        __dialog_qrcode_closed_event_handler() {
            const __this = this;
            __this.__close_loading();
            __this.__stop_timer_to_check_payment_status();
        },

        init(pParameter) {
            const __this = this;

            const defaultParameter = {};
            defaultParameter.getSituationParameter = null;

            defaultParameter.btn_pay = {};
            defaultParameter.btn_pay.text = `支付`;

            const parameter = extend(true, {}, defaultParameter, pParameter);

            __this.__getSituationParameter__ = parameter.getSituationParameter;
            __this.before_pay_event_handler = parameter.before_pay_event_handler;
            __this.pay_successful_event_handler = parameter.pay_successful_event_handler;
            __this.pay_failed_event_handler = parameter.pay_failed_event_handler;

            __this.btn_pay.text = parameter.btn_pay.text;

            Q.when()
                .then(function () {
                    return __this.__init_payment_channel();
                })
                .then(function (data) {
                    __this.__init_payment_amount();

                    if (__this.data_payment_getPayChannel.paymentChannels.length > 0) {
                        const first = __this.data_payment_getPayChannel.paymentChannels[0];
                        if (first.usable) {
                            __this.payment_channel_code_list_shou_xin = [first.code];
                            __this.selected_payment_channel_code = first.code;
                        }
                    }
                })
                .catch(function (ex) {
                    console.error(ex);
                    if (ex) {
                        if (ex.stack) {
                            console.error(ex.stack);
                        }
                    }
                    return Q.reject(ex);
                })
            ;
        },
    },
    mounted() {
        const __this = this;
    },
}
